export const groupItemsWithAssemblyItems = (cartItems: Item[]) => {
  const group: OrderFormItemWithAssemblyItems[] = []

  cartItems.forEach((cartItem, index) => {
    const assemblyItems = cartItems.filter((item) => {
      return item.parentItemIndex === index
    })

    if (cartItem.parentItemIndex === null) {
      group.push({
        orderFormItem: {
          item: cartItem,
          index,
        },
        assemblyItems: assemblyItems.map((item) => ({
          item,
          index: cartItems.findIndex((el) => el.id === item.id),
        })),
      })
    }
  })

  return group
}
